<p-dialog [(visible)]="visibility" [resizable]="false" appendTo="body" [modal]="true" [closeOnEscape]="true"
  (onHide)="closeDialogEvent()" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '32vw' }"
  styleClass="test">
  <ng-template pTemplate="header">
    <div class="flex align-items-center">
      <span class="font-semibold text-base text-900 flex align-items-center">{{'Auth.HELP.SUPPORT' | translate}}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <ng-container *ngIf="companyInfoDetail$ | async as companyInfoDetail">
      <div class="px-3 pt-2">
        <h4 class="text-xs mb-3 text-700 uppercase">
          {{ 'Auth.HELP.YOUR_ACC_MANGER' | translate }}
        </h4>
        <div class="flex align-items-center font-bold">
          <p-avatar label="SP"></p-avatar>
          <h4 class="text-base mb-0 ml-3">
            {{companyInfoDetail.compDetails.account_manager ? companyInfoDetail.compDetails.account_manager.name : '--'}}
          </h4>
        </div>
        <div class="border-bottom-2 border-top-2 surface-border w-100  text-h3 mt-3 overflow-hidden">
          <div class="md:flex align-items-center">
            <div class="flex align-items-center mr-4 py-3">
              <i class="fa fa-phone mr-2 opacity-50"></i>
                {{companyInfoDetail.compDetails.account_manager ? companyInfoDetail.compDetails.account_manager.phone_number : '--'}}
            </div>
            <div class="flex align-items-center md:py-3 pb-3 pt-2">
              <i class=" fa fa-envelope font-light mr-2 opacity-50"></i>
              <a href="mailto:support@fitnessforce.com" class="text-primary no-underline">
                {{companyInfoDetail.compDetails.account_manager ? companyInfoDetail.compDetails.account_manager.email : '--'}}
              </a>
            </div>
          </div>
        </div>

        <div class="surface-50 px-5 py-4 -mx-5 border-bottom-1 border-300 mt-4">
          <!-- Got a Question -->
          <div class="flex">
            <i class="fa fa-question opacity-50 mr-2"></i>
            <div>
              <h3 class="text-base font-bold mb-0">
                {{ 'Auth.HELP.GOT_QUESTION' | translate }}
              </h3>
              <p class="text-500 text-sm my-2">
                {{ 'Auth.HELP.GET_ANS' | translate }}
              </p>
              <a href="https://scribehow.com/page/NxT_Training_Document__vdqdglZuS_2jcMJGb8nRew" target="_blank" class="text-primary font-bold text-base no-underline">
                {{ 'Auth.HELP.VISIT_OUR_KNOWLEDGEBASE' | translate }}</a>
            </div>
          </div>
          <!-- Got a Question -->

          <!-- Sales Enquiry -->
          <div class="flex mt-6">
            <i class="fa fa-phone opacity-50 mr-2"></i>
            <div>
              <h3 class="text-base font-bold mb-0">
                {{ 'Auth.HELP.SALES_ENQUIRES' | translate }}
              </h3>
               <p class="font-bold my-3 text-sm">
                <img src="/assets/img/flags/in.svg" alt="India" width="20" class="mr-2" />
                 +91 96199 37739
              </p>
              <a href="mailto:sales@fitnessforce.com"
                class="text-primary font-bold text-base no-underline"><i
                  class=" fa fa-envelope font-light opacity-50 mr-3 text-800"></i>sales&#64;fitnessforce.com
                </a>
              <p class="font-bold my-3 text-sm">
                <img src="/assets/img/flags/us.svg" alt="US" width="20" class="mr-2" />
                +1 5451237896
              </p>
              <a href="mailto:sales-us@fitnessforce.com"
                class="text-primary font-bold text-base no-underline"><i
                  class=" fa fa-envelope font-light opacity-50 mr-3 text-800"></i>sales-us&#64;fitnessforce.com</a>
            </div>
          </div>
          <!-- Sales Enquiry -->
        </div>
      </div>
    </ng-container>
  </ng-template>
</p-dialog>